import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import location from "../../assets/images/location.png";
import { Button } from "antd";
import ClinicProvider from "../../Provider/ClinicProvider";
import SearchProvider from "../../Provider/SearchProvider";
const ClinicDetailsCard = ({ data, doctorName, appointment }) => {
  const { selectedClinicData, setSelectedClinicData } =
    useContext(ClinicProvider);
  const { setClinicFormPopup } = useContext(SearchProvider);
  const navigate = useNavigate();
  console.log("data", data);
  const formHandler = (data) => {
    setSelectedClinicData({
      clinicId: data?._id,
      doctorId: data?.doctor_list?.doctor_id,
      doctorName: doctorName,
    });
    setClinicFormPopup(true);
  };
  // console.log("selectedClinicData", selectedClinicData);
  return (
    <div className="bg-white p-[1.5rem] shadow-[0_3px_10px_rgb(0,0,0,0.2)] mb-[2rem] rounded-[1.5rem]">
      <div className="flex gap-[3rem] items-center flex-wrap lg:flex-nowrap  flex-col md:flex-row ">
        <div
          className="w-[100px] cursor-pointer hidden md:block"
          onClick={() => navigate(`/clinic/${data?.slug}`)}
        >
          <img
            src={`${process.env.REACT_APP_BASE}${data?.logo_image}`}
            alt={`${data?.name}`}
            className="w-[100px] h-auto "
          />
        </div>
        <div className="w-full md:w-[calc(100%-130px)] lg:w-[50vw]">
          <h3
            className="font-secondary text-black font-medium text-[20px] hover:text-primary transition-all cursor-pointer"
            onClick={() => navigate(`/clinic/${data?.slug}`)}
          >
            {data?.name}
          </h3>
          <div
            className="w-[100px] cursor-pointer block md:hidden my-[10px]"
            onClick={() => navigate(`/clinic/${data?.slug}`)}
          >
            <img
              src={`${process.env.REACT_APP_BASE}${data?.logo_image}`}
              alt={`${data?.name}`}
              className="w-[100px] h-auto "
            />
          </div>
          <p className="font-primary font-thin text-[1.4rem] mt-4 text-[#666363] text-justify lg:text-left">
            {data?.short_description}
          </p>
          <div className="flex gap-4 items-center mt-4">
            <img src={location} className="w-[1.5rem] h-auto" />
            <div className="font-primary font-thin text-[1.4rem] text-[#666363]">
              {data?.address_line1}, {data?.address_line2}
              {"-"}
              {data?.pin_code}
            </div>
          </div>
        </div>
        <div className="w-[100%] lg:w-[30vw] flex gap-4 justify-end">
          {appointment && (
            <button
              type="primary"
              className="min-w-[150px] bg-primary text-white font-primary font-medium text-[1.4rem] py-[0.8rem] rounded-md hover:bg-milkgreen transition-all"
              onClick={() => formHandler(data)}
            >
              For Appointment
            </button>
          )}
          <button
            type="primary"
            className="min-w-[150px] bg-white text-primary font-primary font-medium text-[1.4rem] py-[0.8rem] rounded-md hover:bg-primary hover:text-white transition-all border border"
            onClick={() => navigate(`/clinic/${data?.slug}`)}
          >
            View Clinic
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClinicDetailsCard;
